"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Commander Spellbook API
 * API for Commander Spellbook, the combo database engine for Magic: The Gathering
 *
 * The version of the OpenAPI document: 4.8.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfPaginatedVariantUpdateSuggestionList = instanceOfPaginatedVariantUpdateSuggestionList;
exports.PaginatedVariantUpdateSuggestionListFromJSON = PaginatedVariantUpdateSuggestionListFromJSON;
exports.PaginatedVariantUpdateSuggestionListFromJSONTyped = PaginatedVariantUpdateSuggestionListFromJSONTyped;
exports.PaginatedVariantUpdateSuggestionListToJSON = PaginatedVariantUpdateSuggestionListToJSON;
exports.PaginatedVariantUpdateSuggestionListToJSONTyped = PaginatedVariantUpdateSuggestionListToJSONTyped;
const variantUpdateSuggestion_1 = require("./variantUpdateSuggestion");
/**
 * Check if a given object implements the PaginatedVariantUpdateSuggestionList interface.
 */
function instanceOfPaginatedVariantUpdateSuggestionList(value) {
    if (!('count' in value) || value['count'] === undefined)
        return false;
    if (!('next' in value) || value['next'] === undefined)
        return false;
    if (!('previous' in value) || value['previous'] === undefined)
        return false;
    if (!('results' in value) || value['results'] === undefined)
        return false;
    return true;
}
function PaginatedVariantUpdateSuggestionListFromJSON(json) {
    return PaginatedVariantUpdateSuggestionListFromJSONTyped(json, false);
}
function PaginatedVariantUpdateSuggestionListFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'count': json['count'],
        'next': json['next'],
        'previous': json['previous'],
        'results': (json['results'].map(variantUpdateSuggestion_1.VariantUpdateSuggestionFromJSON)),
    };
}
function PaginatedVariantUpdateSuggestionListToJSON(json) {
    return PaginatedVariantUpdateSuggestionListToJSONTyped(json, false);
}
function PaginatedVariantUpdateSuggestionListToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'count': value['count'],
        'next': value['next'],
        'previous': value['previous'],
        'results': (value['results'].map(variantUpdateSuggestion_1.VariantUpdateSuggestionToJSON)),
    };
}
//# sourceMappingURL=paginatedVariantUpdateSuggestionList.js.map